import * as React from "react";
import { ThemeType } from "@theme";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { AppBar, Tabs, Tab } from "@material-ui/core";

export type AppBarTabsProps = {
  value: string;
  onChange: (v: string) => void;
  routes: {
    [route: string]: {
      content: React.ReactNode;
      icon?: React.ReactNode;
      show?: boolean;
    };
  };
};

export function AppBarTabs({ value, routes, onChange }: AppBarTabsProps) {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.appBar}>
        <Tabs value={value} onChange={(_, v) => onChange(v)} indicatorColor="primary">
          {Object.keys(routes).map(
            (key) =>
              (routes[key].show ?? true) && (
                <Tab
                  key={key}
                  value={key}
                  label={
                    <div className={classes.tabItem}>
                      {routes[key].icon}
                      {routes[key].content}
                    </div>
                  }
                />
              )
          )}
        </Tabs>
      </AppBar>
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    zIndex: 10
  },

  appBar: {
    flex: "0 0",
    backgroundColor: theme.palette.background.paper
  },

  tabItem: {
    display: "flex",
    alignItems: "center",

    "& > svg": {
      fontSize: 18,
      marginRight: 4
    }
  }
}));
